package com.gsb.vyapar.bhagya.datasource.cache

import app.cash.sqldelight.SuspendingTransacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.gsb.vyapar.bhagya.datasource.cache.composeApp.newInstance
import com.gsb.vyapar.bhagya.datasource.cache.composeApp.schema
import kotlin.Unit

public interface GsbVyaparBhagyaDatabase : SuspendingTransacter {
  public val gsbVyaparBhagyaDatabaseQueries: GsbVyaparBhagyaDatabaseQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.AsyncValue<Unit>>
      get() = GsbVyaparBhagyaDatabase::class.schema

    public operator fun invoke(driver: SqlDriver): GsbVyaparBhagyaDatabase =
        GsbVyaparBhagyaDatabase::class.newInstance(driver)
  }
}
